import { render, staticRenderFns } from "./ThePaymentHistory.vue?vue&type=template&id=2cb6fb0a&"
import script from "./ThePaymentHistory.vue?vue&type=script&lang=js&"
export * from "./ThePaymentHistory.vue?vue&type=script&lang=js&"
import style0 from "./ThePaymentHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports